import { Price } from 'src/features/pricing/components/price';
import { StyledBlock, StyledMessage, StyledOldPrice, StyledPrice } from './discount-message.styles';
import type { DiscountMessageProps } from './discount-message.types';
export const DiscountMessage = ({
  isPremium,
  yearlyPrice,
  discountedYearlyPrice,
  symbol
}: DiscountMessageProps) => <StyledMessage data-testid="campaign-promotion-discount-message" data-sentry-element="StyledMessage" data-sentry-component="DiscountMessage" data-sentry-source-file="discount-message.tsx">
    {isPremium ? 'Switch to annual today for' : 'Subscribe today for'}{' '}
    <StyledBlock data-sentry-element="StyledBlock" data-sentry-source-file="discount-message.tsx">
      <StyledOldPrice price={yearlyPrice} symbol={symbol} data-sentry-element="StyledOldPrice" data-sentry-source-file="discount-message.tsx">
        {(int, fraction) => int + fraction}
      </StyledOldPrice>{' '}
      <StyledPrice data-sentry-element="StyledPrice" data-sentry-source-file="discount-message.tsx">
        <Price price={discountedYearlyPrice} symbol={symbol} data-sentry-element="Price" data-sentry-source-file="discount-message.tsx">
          {(int, fraction) => int + fraction}
        </Price>
        /year
      </StyledPrice>
    </StyledBlock>
  </StyledMessage>;